/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import { makeStyles } from 'tss-react/mui';

import { Theme } from '@mui/material/styles';

const AddModuleDialogStyles = makeStyles()((theme: Theme) => ({
	dialogTitle: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		fontSize: '1.25rem',
		fontFamily: theme.typography.fontFamilyBold,
		padding: theme.spacing(2, 3),
		borderBottom: '1px solid #e0e0e0',
	},

	dialogContent: {
		padding: theme.spacing(0),
		'&:first-of-type': {
			paddingTop: 0,
		},
	},

	closeButton: {
		color: '#666',
		cursor: 'pointer',
		transition: 'color 0.2s',
		'&:hover': {
			color: '#000',
		},
	},

	headerRow: {
		backgroundColor: '#E1E1E3',
		padding: theme.spacing(2, 2),
		fontFamily: theme.typography.fontFamilyBold,
		fontSize: '0.95rem',
	},

	headerCell: {
		fontFamily: theme.typography.fontFamilyBold,
	},

	row: {
		padding: theme.spacing(2),
		minHeight: '60px',
		display: 'flex',
		alignItems: 'center',
		borderBottom: '1px solid #f0f0f0',
	},

	evenRow: {
		backgroundColor: '#fff',
	},

	oddRow: {
		backgroundColor: '#E1E1E3',
	},

	content: {
		cursor: 'pointer',
		'&:hover': {
			opacity: 0.8,
		},
	},

	arrowIcon: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		color: '#666',
	},

	moduleText: {
		fontSize: '0.9rem',
		lineHeight: '1.5',
		color: '#333',
		paddingRight: theme.spacing(1),
	},

	addButton: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},

	actionButton: {
		textTransform: 'none',
		fontSize: '0.85rem',
		padding: theme.spacing(0.75, 2),
		borderColor: '#666',
		color: '#333',
		whiteSpace: 'nowrap',
		'&:hover': {
			borderColor: '#333',
			backgroundColor: 'rgba(0, 0, 0, 0.04)',
		},
	},

	addedButton: {
		textTransform: 'none',
		fontSize: '0.85rem',
		padding: theme.spacing(0.75, 2),
		borderColor: '#ccc',
		color: '#999',
		whiteSpace: 'nowrap',
		'& svg': {
			marginRight: theme.spacing(0.5),
		},
	},

	truncated: {
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},

	contentContainer: {
		paddingBottom: theme.spacing(2),
	},

	loadingContainer: {
		display: 'flex',
		justifyContent: 'center',
		padding: theme.spacing(8, 0),
	},

	loading: {
		color: theme.palette.secondary.light,
	},
}));

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export default AddModuleDialogStyles;
